import { connect } from '@atlassian/jira-react-redux';
import triggerAnalyticsEvent from '@atlassian/jira-servicedesk-automation-common/src/analytics';
import { customBlueprintModuleKey } from '../../../../model';
import { createRuleAction, selectBlueprintAction } from '../../../../state/actions/blueprint';
import {
	getBlueprintModuleKeys,
	getSelectedBlueprintModuleKey,
} from '../../../../state/selectors/blueprint';
import type { State } from '../../../../state/types';
import BlueprintList from './blueprint-list';
import BlueprintOption from './common/blueprint-option';
import SelectBlueprint from './view';

const mapStateToProps = (state: State) => ({
	blueprintModuleKeys: getBlueprintModuleKeys(state),
	defaultBlueprintModuleKey: customBlueprintModuleKey,
	selectedBlueprint: getSelectedBlueprintModuleKey(state),
	BlueprintListComponent: BlueprintList,
	BlueprintOptionComponent: BlueprintOption,
});

export default connect(mapStateToProps, {
	// @ts-expect-error - TS7006 - Parameter 'selectedBlueprintKey' implicitly has an 'any' type.
	onSelect: (selectedBlueprintKey) => {
		triggerAnalyticsEvent('summary.blueprint-dialog.blueprint.selected');
		return selectBlueprintAction(selectedBlueprintKey);
	},
	onCreate: () => {
		triggerAnalyticsEvent('summary.blueprint-dialog.blueprint.create.begin');
		return createRuleAction();
	},
})(SelectBlueprint);
